import { useMonth } from '@datepicker-react/hooks';
import P from '../../texts/p/P';
import * as S from '../DatePicker.styles';
import { MONTH_NAMES } from '../../../utils/Constants';
import Day from './Day.inner';
import styled from 'styled-components';

type MonthProps = {
  year: number;
  month: number;
  firstDayOfWeek: 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined;
  onMonthYearChange: (month: number, year: number) => void;
};

const dayOfWeek = {
  Mo: 'L',
  Tu: 'M',
  We: 'M',
  Th: 'J',
  Fr: 'V',
  Sa: 'S',
  Su: 'D',
};

const isStartOrEndOfRowGrid = (index) => {
  const rest = (index + 1) % 7;
  if (index === 0 || rest === 1) return 'startRowGrid';
  if (rest === 0) return 'endRowGrid';
  return false;
};

const getYearsRange = (minYear: number, maxYear: number) => {
  const years = [];
  for (let y = minYear; y <= maxYear; y++) years.push(y);
  return years;
};

const DatePickerHeaderFlex = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding: 12px 0 16px 0;
  margin-bottom: 8px;

  select {
    padding: 4px 8px;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    font-size: 1rem;
    background: #fff;
    min-width: 90px;
    outline: none;
    transition: border 0.2s;
  }
  select:focus {
    border: 1.5px solid #00bfae;
  }
`;

function Month(props: MonthProps) {
  const { year, month, firstDayOfWeek, onMonthYearChange } = props;

  const { days, weekdayLabels } = useMonth({
    year,
    month,
    firstDayOfWeek,
  });

  if (
    typeof month !== 'number' ||
    isNaN(month) ||
    typeof year !== 'number' ||
    isNaN(year)
  ) {
    return <div>Error: Fecha inválida</div>;
  }

  const minYear = 1950;
  const maxYear = new Date().getFullYear() + 5;
  const years = getYearsRange(minYear, maxYear);

  return (
    <S.DatePickerGrid months={2}>
      <DatePickerHeaderFlex>
        <select
          value={month}
          onChange={(e) => onMonthYearChange(Number(e.target.value), year)}
        >
          {MONTH_NAMES.map((name, idx) => (
            <option key={name} value={idx}>
              {name}
            </option>
          ))}
        </select>
        <select
          value={year}
          onChange={(e) => onMonthYearChange(month, Number(e.target.value))}
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </DatePickerHeaderFlex>
      <S.DatePickerWeek>
        {weekdayLabels.map((dayLabel) => (
          <S.DatePickerWeekContent key={dayLabel}>
            <P type='4' variant='neutral' align='center'>
              {dayOfWeek[dayLabel]}
            </P>
          </S.DatePickerWeekContent>
        ))}
      </S.DatePickerWeek>
      <S.DayGrid>
        {days.map((day, index) => {
          if (typeof day === 'object') {
            return (
              <Day
                date={day.date}
                key={day.date.toString()}
                label={day.dayLabel}
                isStartOrEndOfRowGrid={isStartOrEndOfRowGrid(index)}
              />
            );
          }

          return <div key={index} />;
        })}
      </S.DayGrid>
    </S.DatePickerGrid>
  );
}

export default Month;
